import { Helmet } from 'react-helmet-async';

export default function SEOHead({ title, description, keywords, canonical, ogImage, ogType, noindex, article, faqs }) {
  var fullTitle = title ? (title.indexOf('ChannelLoyalty') !== -1 ? title : title + ' | ChannelLoyalty') : 'ChannelLoyalty | B2B Channel Loyalty Platform';
  var metaDesc = description || "India's leading B2B channel loyalty platform. Design & manage dealer loyalty, distributor rewards, retailer incentives across industries.";
  var pathCanonical = 'https://channelloyalty.ai' + (typeof window !== 'undefined' && window.location.pathname !== '/' ? window.location.pathname.replace(/\/+$/, '') : '/');
  var canonicalUrl = canonical || pathCanonical;
  var image = ogImage || 'https://channelloyalty.ai/og-image.png';
  var type = ogType || 'website';

  var articleSchema = null;
  if (article) {
    articleSchema = {
      "@context": "https://schema.org",
      "@type": "Article",
      "headline": title || "",
      "description": metaDesc,
      "url": canonicalUrl,
      "datePublished": article.datePublished || new Date().toISOString(),
      "dateModified": article.dateModified || article.datePublished || new Date().toISOString(),
      "author": {
        "@type": "Organization",
        "name": "ChannelLoyalty",
        "url": "https://channelloyalty.ai"
      },
      "publisher": {
        "@type": "Organization",
        "name": "ChannelLoyalty",
        "url": "https://channelloyalty.ai",
        "logo": {
          "@type": "ImageObject",
          "url": "https://channelloyalty.ai/logo.png"
        }
      },
      "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": canonicalUrl
      }
    };
    if (keywords) {
      articleSchema.keywords = keywords;
    }
    if (article.industry) {
      articleSchema.about = {
        "@type": "Thing",
        "name": article.industry + " Channel Loyalty"
      };
    }
  }

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={metaDesc} />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1"} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDesc} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:site_name" content="ChannelLoyalty" />
      <meta property="og:locale" content="en_US" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDesc} />
      <meta name="twitter:image" content={image} />

      {articleSchema && (
        <script type="application/ld+json">
          {JSON.stringify(articleSchema)}
        </script>
      )}
    </Helmet>
  );
}
